var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 46,
    viewBox: "0 0 36 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1373 9.94886L26.9165 4.11066L23.7106 0.174805H12.2894L9.08349 4.11066L15.8627 10.0473C6.9462 11.0968 0 18.5094 0 27.529C0 37.2703 8.08163 45.1748 18 45.1748C27.9184 45.1748 36 37.2375 36 27.4962C36 18.4766 29.0538 10.9656 20.1373 9.94886ZM18 41.0422C10.3859 41.0422 4.20779 34.9744 4.20779 27.4962C4.20779 20.0181 10.3859 13.9503 17.9666 13.9503C25.5807 13.9503 31.7588 20.1493 31.7588 27.5946C31.7588 35.0728 25.5807 41.0422 17.9666 41.0422H18Z",
    fill: "#FF5E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.70e7a2f7999112b5e812ec6b52a84d11.svg";
export { ForwardRef as ReactComponent };